
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UICheckboxList',
  props: {
    checkboxList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const isChecked = (checkbox) => {
      return props.value.includes(checkbox.id);
    };

    const addToChecked = (checkbox) => {
      const cloneChecked = [...props.value];
      cloneChecked.push(checkbox.id);
      return cloneChecked;
    };

    const removeFromChecked = (checkbox) => {
      return [...props.value].filter((el) => el !== checkbox.id);
    };

    const handleChecked = (checkbox) => {
      if (!checkbox.isChecked) {
        emit('input', removeFromChecked(checkbox.value));
        return;
      }

      emit('input', addToChecked(checkbox.value));
    };

    return { isChecked, handleChecked };
  },
});
